var _defs, _polygon, _polygon2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSponser1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 677.34 268.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#cf202e;}.cls-2{fill-rule:evenodd;}.cls-3{fill:#fff;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "407.27 66.76 296.36 66.76 305.57 33.56 416.48 33.56 407.27 66.76"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "332.12 122.83 391.72 122.84 400.93 89.64 290.02 89.64 263.72 184.46 315.03 184.46 332.12 122.83"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M457.9,150.14a4.94,4.94,0,0,1-2.52-3.06,4.19,4.19,0,0,1-.11-1.17,5.37,5.37,0,0,1,.18-1.1l20.09-72.45A6.69,6.69,0,0,1,478.6,68c1.47-.82,4-1.24,7.57-1.24h55.4l9.2-33.2H473.1c-14.15,0-24,1.68-29.76,4.87s-9.73,8.84-12,17.15L402.65,158.89a20.45,20.45,0,0,0-.76,4.52,16.06,16.06,0,0,0,.44,4.6c1.33,5,4.61,9,9.91,12s11.77,4.42,19.55,4.42h81.3l9.21-33.2H462.88A10.16,10.16,0,0,1,457.9,150.14Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M151.4,33.56,116.64,158.89a20.42,20.42,0,0,0-.75,4.52,16.06,16.06,0,0,0,.44,4.6c1.33,5,4.6,9,9.91,12s11.76,4.42,19.55,4.42l57.83,0c14.15,0,24-1.68,29.76-4.86s9.73-8.85,12-17.16L281.16,33.56H229.85l-31.09,112.1A6.72,6.72,0,0,1,195.7,150c-1.46.81-4,1.24-7.57,1.24h-8.84a10.12,10.12,0,0,1-5-1.12,4.94,4.94,0,0,1-2.52-3.06,4.22,4.22,0,0,1-.11-1.18,4.77,4.77,0,0,1,.18-1.09L202.7,33.56Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M557.5,33.56a4,4,0,1,1-4,4A3.83,3.83,0,0,1,557.5,33.56Zm0,7.11a2.9,2.9,0,0,0,3-3.11,3.06,3.06,0,1,0-6.12,0A2.91,2.91,0,0,0,557.5,40.67Zm.13-2.58h-.75V39.3h-.61V35.64h1.43c.82,0,1.15.35,1.15,1v.5a.87.87,0,0,1-.53.86l1,1.33h-.75Zm0-1.88h-.8v1.3h.8c.4,0,.53-.15.53-.42v-.44C558.21,36.3,558.05,36.21,557.68,36.21Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M17.69,233.14c10.26,0,17.74,7.32,17.74,17.53S28,268.21,17.69,268.21,0,260.89,0,250.67,7.47,233.14,17.69,233.14Zm0,6.4c-6.25,0-10.27,4.78-10.27,11.13s4,11.14,10.27,11.14S28,257,28,250.67,23.94,239.54,17.69,239.54Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M40.51,233.7h24v6.2H47.73v7.37H64.14v6.2H47.73V267.6H40.51Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M69.53,233.7h24v6.2H76.75v7.37H93.16v6.2H76.75V267.6H69.53Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M98.55,233.7h7.22v33.9H98.55Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M110.85,250.67c0-10.41,7.88-17.53,17.79-17.53a15.66,15.66,0,0,1,14.43,8.28l-6.2,3.05a9.28,9.28,0,0,0-8.23-4.93c-5.9,0-10.37,4.73-10.37,11.13s4.47,11.14,10.37,11.14a9.19,9.19,0,0,0,8.23-4.93l6.2,3a15.75,15.75,0,0,1-14.43,8.33C118.73,268.21,110.85,261.09,110.85,250.67Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M147.39,233.7h7.22v33.9h-7.22Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M182.92,261.76H167.77l-2.13,5.84h-7.93l13.11-33.9h9.05l13.06,33.9h-7.88ZM169.7,255.5h11.24L175.35,240Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M196.08,233.7h7.22v27.55h14.33v6.35H196.08Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M235.67,233.7h17.84c6.46,0,9.76,4.12,9.76,8.64,0,4.27-2.64,7.12-5.84,7.78,3.61.55,6.5,4.06,6.5,8.33,0,5.08-3.4,9.15-9.86,9.15h-18.4Zm16.27,13.62a3.74,3.74,0,1,0,0-7.47h-9.05v7.47Zm.25,14.13c2.75,0,4.37-1.57,4.37-4,0-2.14-1.52-4-4.37-4h-9.3v8Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M269.37,233.7h24v6.2H276.59v7.37H293v6.2H276.59v7.88h16.77v6.25h-24Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M306.83,240.05h-9.91V233.7h27v6.35H314.1V267.6h-7.27Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M336.41,240.05H326.5V233.7h27v6.35h-9.86V267.6h-7.27Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M358.16,233.7h7.22v33.9h-7.22Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M379.3,244.83V267.6h-7.21V233.7h7.42l15.7,22v-22h7.22v33.9h-7Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M425.55,233.14a15.86,15.86,0,0,1,14,7.42l-6,3.25a9.64,9.64,0,0,0-8-4.27c-6.14,0-10.62,4.73-10.62,11.13s4.48,11.14,10.62,11.14a11.38,11.38,0,0,0,7.32-2.6V255.1h-9v-6.2H440v13a18.82,18.82,0,0,1-14.44,6.4c-9.91,0-18-6.91-18-17.59S415.64,233.14,425.55,233.14Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M458.74,233.7H474.6c7.37,0,11.39,5,11.39,10.93s-4.07,10.82-11.39,10.82H466V267.6h-7.22Zm14.89,6.2H466v9.35h7.67c2.85,0,5-1.83,5-4.67A4.66,4.66,0,0,0,473.63,239.9Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M508.3,261.76H493.15L491,267.6h-7.93l13.11-33.9h9.05l13.06,33.9h-7.88Zm-13.22-6.26h11.24L500.72,240Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M534,255.45h-5.28V267.6h-7.22V233.7h15.86c7.06,0,11.38,4.62,11.38,10.93,0,6-3.76,9.2-7.42,10.06l7.63,12.91h-8.29Zm2.29-15.55h-7.57v9.35h7.57c2.9,0,5.08-1.83,5.08-4.67S539.15,239.9,536.25,239.9Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M561.46,240.05h-9.91V233.7h27v6.35h-9.86V267.6h-7.27Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M590.43,244.83V267.6h-7.22V233.7h7.42l15.71,22v-22h7.22v33.9h-7Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M620.26,233.7h24v6.2H627.48v7.37H643.9v6.2H627.48v7.88h16.77v6.25h-24Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M662.4,255.45h-5.29V267.6h-7.22V233.7h15.86c7.07,0,11.39,4.62,11.39,10.93,0,6-3.76,9.2-7.42,10.06l7.62,12.91h-8.28Zm2.29-15.55h-7.58v9.35h7.58c2.89,0,5.08-1.83,5.08-4.67S667.58,239.9,664.69,239.9Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSponser1);
export default __webpack_public_path__ + "static/media/sponser1.23c9c58fa23775f9b8ef41a0d7398c5b.svg";
export { ForwardRef as ReactComponent };